import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const BasantPanchami = () => {  

  const images = [
    { id: 1, src: "images/gallery/basant-1.jpg", alt: "BasantPanchami", title: "BasantPanchami", group: "BasantPanchami" },
    { id: 2, src: "images/gallery/basant-2.jpg", alt: "BasantPanchami", title: "BasantPanchami", group: "BasantPanchami" },
    { id: 3, src: "images/gallery/basant-3.jpg", alt: "BasantPanchami", title: "BasantPanchami", group: "BasantPanchami" },
    { id: 4, src: "images/gallery/basant.jpg", alt: "BasantPanchami", title: "BasantPanchami", group: "BasantPanchami" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Happy Basant Panchami 2024" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Happy Basant Panchami 2024</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BasantPanchami;
